import { useState } from "react";

import Point from "../screens/Point";
import Location from "../screens/Location";
import Account from "../screens/Account";

import style from "../style/components/Tabview.module.css";

const Tabview = ({ index = 0 }) => {
    const [tabIndex, setTabIndex] = useState<number>(index);
    const tabName = ["point", "location", "member"] as const;

    return (
        <>
            {[<Point />, <Location />, <Account />][tabIndex]}
            <Tabbar
                selected={tabName[tabIndex]}
                setTabIndex={setTabIndex}
            ></Tabbar>
        </>
    );
};

const Tabbar = ({
    selected,
    setTabIndex,
}: {
    selected: "point" | "location" | "member";
    setTabIndex: (n: number) => void;
}) => {
    return (
        <div className={style["container"]}>
            <span className={style["cover"]} />
            <div className={style["unit"]}>
                <button
                    className={style["button--tabbar"]}
                    onClick={() => setTabIndex(0)}
                >
                    <Icon name="point" active={selected === "point"} />
                    <p
                        className={[
                            style["text--tabbar"],
                            selected === "point" &&
                                style["text--tabbar--selected"],
                        ]
                            .filter(Boolean)
                            .join(" ")}
                    >
                        포인트
                    </p>
                </button>
            </div>
            <div className={style["unit"]}>
                <button
                    className={style["button--tabbar"]}
                    onClick={() => setTabIndex(1)}
                >
                    <Icon name="location" active={selected === "location"} />
                    <p
                        className={[
                            style["text--tabbar"],
                            selected === "location" &&
                                style["text--tabbar--selected"],
                        ]
                            .filter(Boolean)
                            .join(" ")}
                    >
                        위치
                    </p>
                </button>
            </div>
            <div className={style["unit"]}>
                <button
                    className={style["button--tabbar"]}
                    onClick={() => setTabIndex(2)}
                >
                    <Icon name="member" active={selected === "member"} />
                    <p
                        className={[
                            style["text--tabbar"],
                            selected === "member" &&
                                style["text--tabbar--selected"],
                        ]
                            .filter(Boolean)
                            .join(" ")}
                    >
                        회원
                    </p>
                </button>
            </div>
        </div>
    );
};

const Icon = ({
    name,
    active = false,
}: {
    name: "point" | "location" | "member";
    active: boolean;
}) => {
    return (
        <>
            <div className={style["wrapper--icon"]}>
                {name == "point" && (
                    <svg
                        width="19"
                        height="25"
                        viewBox="0 0 19 25"
                        fill={active ? "var(--color-brand)" : "#999999"}
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M9.48828 24.5391C8.84375 24.5391 8.52734 24.1055 7.87109 23.2148L0.875 13.875C0.546875 13.4414 0.371094 13.0078 0.371094 12.5391C0.371094 12.0586 0.546875 11.6367 0.875 11.2031L7.87109 1.85156C8.52734 0.972656 8.84375 0.539062 9.48828 0.539062C10.1328 0.539062 10.4492 0.972656 11.1172 1.85156L18.1133 11.2031C18.4297 11.6367 18.6172 12.0586 18.6172 12.5391C18.6172 13.0078 18.4297 13.4414 18.1133 13.875L11.1172 23.2148C10.4492 24.1055 10.1328 24.5391 9.48828 24.5391ZM9.48828 22.0664C9.54688 22.0664 9.57031 22.0312 9.60547 21.9727L16.3906 12.8555C16.4844 12.7266 16.5078 12.6328 16.5078 12.5391C16.5078 12.4453 16.4844 12.3516 16.3906 12.2227L9.60547 3.09375C9.57031 3.04688 9.54688 3.01172 9.48828 3.01172C9.42969 3.01172 9.40625 3.04688 9.37109 3.09375L2.59766 12.2227C2.49219 12.3516 2.48047 12.4453 2.48047 12.5391C2.48047 12.6328 2.49219 12.7266 2.59766 12.8555L9.37109 21.9727C9.40625 22.0312 9.42969 22.0664 9.48828 22.0664Z" />
                    </svg>
                )}
                {name == "location" && (
                    <svg
                        width="29"
                        height="29"
                        viewBox="0 0 29 29"
                        fill={active ? "var(--color-brand)" : "#999999"}
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M1.09375 15.3945C0.625 15.3945 0.25 15.0195 0.25 14.5508C0.25 14.082 0.625 13.7188 1.09375 13.7188H3.47266C3.88281 8.28125 8.23047 3.91016 13.6562 3.5V1.14453C13.6562 0.675781 14.0312 0.300781 14.5 0.300781C14.9688 0.300781 15.332 0.675781 15.332 1.14453V3.5C20.7695 3.91016 25.1172 8.28125 25.5273 13.7188H27.9062C28.375 13.7188 28.75 14.082 28.75 14.5508C28.75 15.0195 28.375 15.3945 27.9062 15.3945H25.5273C25.1172 20.832 20.7695 25.2031 15.332 25.6133V27.957C15.332 28.4258 14.9688 28.8008 14.5 28.8008C14.0312 28.8008 13.6562 28.4258 13.6562 27.957V25.6133C8.23047 25.2031 3.88281 20.832 3.47266 15.3945H1.09375ZM14.5 9.92188C14.0312 9.92188 13.6562 9.54688 13.6562 9.07812V5.41016C9.26172 5.80859 5.82812 9.26562 5.45312 13.7188H9.02734C9.49609 13.7188 9.87109 14.082 9.87109 14.5508C9.87109 15.0195 9.49609 15.3945 9.02734 15.3945H5.45312C5.82812 19.8359 9.26172 23.293 13.6562 23.6914V20.0234C13.6562 19.5547 14.0312 19.1914 14.5 19.1914C14.9688 19.1914 15.332 19.5547 15.332 20.0234V23.6914C19.7383 23.293 23.1719 19.8359 23.5469 15.3945H19.9727C19.5039 15.3945 19.1289 15.0195 19.1289 14.5508C19.1289 14.082 19.5039 13.7188 19.9727 13.7188H23.5469C23.1719 9.26562 19.7383 5.80859 15.332 5.41016V9.07812C15.332 9.54688 14.9688 9.92188 14.5 9.92188Z" />
                    </svg>
                )}
                {name == "member" && (
                    <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill={active ? "var(--color-brand)" : "#999999"}
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M12.5 24.4922C5.97266 24.4922 0.546875 19.0664 0.546875 12.5391C0.546875 6 5.96094 0.585938 12.4883 0.585938C19.0273 0.585938 24.4531 6 24.4531 12.5391C24.4531 19.0664 19.0391 24.4922 12.5 24.4922ZM12.5 16.5234C16.0273 16.5234 18.7461 17.7891 19.9297 19.1953C21.5117 17.4375 22.4727 15.1055 22.4609 12.5391C22.4492 7.00781 18.0195 2.57812 12.4883 2.57812C6.95703 2.57812 2.55078 7.00781 2.55078 12.5391C2.55078 15.1055 3.5 17.4258 5.07031 19.1953C6.26562 17.7891 8.97266 16.5234 12.5 16.5234ZM12.5 14.5312C10.25 14.5078 8.49219 12.6328 8.48047 10.1133C8.46875 7.74609 10.25 5.78906 12.5 5.78906C14.75 5.78906 16.5195 7.74609 16.5195 10.1133C16.5195 12.6328 14.7617 14.5547 12.5 14.5312Z" />
                    </svg>
                )}
            </div>
        </>
    );
};

export default Tabview;
